/**
 * Hero definitions and constants
 */

export const HEROES = {
  CHECKUP: 'checkup',
  TELEPORTAL: 'teleportal',
  QULTUREUP: 'qultureup',
  CARE: 'care',
  PASSPORT: 'passport',
} as const;

export type HeroId = (typeof HEROES)[keyof typeof HEROES];

export const HERO_LABELS: Record<HeroId, string> = {
  checkup: 'CheckUp',
  teleportal: 'TelePortal',
  qultureup: 'QultureUp',
  care: 'Care',
  passport: 'Passport',
};

export const HERO_ICONS: Record<HeroId, string> = {
  checkup: '✅',
  teleportal: '🚀',
  qultureup: '📚',
  care: '💚',
  passport: '🛂',
};

export const ALL_HEROES: HeroId[] = [
  HEROES.CHECKUP,
  HEROES.TELEPORTAL,
  HEROES.QULTUREUP,
  HEROES.CARE,
  HEROES.PASSPORT,
];
